module.exports = __webpack_public_path__ + "static/media/waschbecken_richtig.f4c710de.jpg";